module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "customer-list"
  }, [_c('h2', [_vm._v("顧客一覧")]), _vm._v(" "), _c('v-client-table', {
    attrs: {
      "data": _vm.tableData,
      "columns": _vm.columns,
      "options": _vm.options
    },
    on: {
      "row-click": _vm.row_click
    }
  }), _vm._v(" "), _c('customer-detail', {
    attrs: {
      "selected_row": _vm.selected_row
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-461fab5d","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/CustomerList.vue
// module id = 210
// module chunks = 1